import { useStore } from './store';
import { TYPE_CONFIG } from './constants';
import { Plus, Search } from 'lucide-react';
import { useState } from 'react';

export const NodeLibrary = () => {
  const addNodeByType = useStore((s) => s.addNodeByType);
  const [search, setSearch] = useState('');

  const filteredNodes = Object.entries(TYPE_CONFIG).filter(
    ([type, config]) =>
      type !== 'webhook_result' &&
      (config.label.toLowerCase().includes(search.toLowerCase()) ||
      config.description.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div className="w-full h-full flex flex-col overflow-hidden bg-white">
      <div className="p-4 border-b border-zinc-100 space-y-3">
        <div>
          <h3 className="text-xs font-semibold text-zinc-900 tracking-tight">Node Library</h3>
          <p className="text-[11px] text-zinc-500 mt-0.5">Drag or click to add components to canvas</p>
        </div>
        
        <div className="relative">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400 pointer-events-none" />
          <input 
            type="text" 
            placeholder="Search nodes..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full pl-9 pr-3 py-1.5 bg-zinc-50 border border-zinc-200 rounded-lg text-xs text-zinc-900 placeholder:text-zinc-400 focus:outline-none focus:border-zinc-900 focus:bg-white transition-colors"
          />
        </div>
      </div>

      <div className="flex-1 overflow-y-auto p-3 space-y-2 custom-scrollbar">
        {filteredNodes.map(([type, config]) => {
          const Icon = config.icon;
          
          return (
            <button
              key={type}
              onClick={() => addNodeByType(type)}
              draggable={true}
              onDragStart={(event) => {
                event.dataTransfer.setData('application/reactflow', type);
                event.dataTransfer.effectAllowed = 'move';
              }}
              className="w-full flex items-start gap-3 p-2.5 rounded-xl border border-zinc-200/80 bg-white hover:border-zinc-300 hover:shadow-2xs transition-all group text-left cursor-grab active:cursor-grabbing"
            >
              <div className={`w-8 h-8 rounded-lg ${config.color} flex items-center justify-center shrink-0 group-hover:scale-105 transition-transform overflow-hidden`}>
                {typeof Icon === 'string' ? (
                  <img src={Icon} alt="" className="w-full h-full object-contain scale-110" />
                ) : (
                  <Icon size={16} />
                )}
              </div>
              <div className="overflow-hidden flex-1 min-w-0">
                <div className="flex items-center justify-between mb-0.5">
                  <h4 className="text-xs font-semibold text-zinc-900 truncate">
                    {config.label}
                  </h4>
                  <Plus size={12} className="text-zinc-300 group-hover:text-zinc-900 shrink-0 ml-1 transition-colors" />
                </div>
                <p className="text-[11px] text-zinc-500 leading-normal line-clamp-2">
                  {config.description}
                </p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
